import { M } from './siteStyle';

const preferences = [
  'promotionalOptOut',
  'weeklyOptOut',
  'contestsAndSweepstakesOptOut',
  'newsletterOptOut',
  'pushNotificationMarketingPromosOptOut',
  'pushNotificationWeeklyDealsOptOut',
  'pushNotificationContestsSweepstakesOptOut',
];

const getPreferences = (optList) => {
  const optAll = optList.findIndex((item) => item === 'all') !== -1;
  const consumerPrivacyAgreements = {};
  preferences.forEach((preference) => {
    let isSuspended = optAll ? !optAll : !optList.includes(preference);
    if (M.RG && preference !== 'promotionalOptOut' && preference !== 'weeklyOptOut') {
      isSuspended = true;
    }
    consumerPrivacyAgreements[preference] = {
      suspended: isSuspended,
      reason: '',
    };
  });
  return { consumerPrivacyAgreements };
};

export default getPreferences;
